var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M14.6667 14.1667H14V6.65335C14 6.24002 13.8133 5.85335 13.4867 5.60002L12.6667 4.96002L12.6533 3.32669C12.6533 2.96002 12.3533 2.66669 11.9867 2.66669H9.71333L8.81999 1.97335C8.33999 1.59335 7.66 1.59335 7.18 1.97335L2.51333 5.60002C2.18666 5.85335 1.99999 6.24002 1.99999 6.64669L1.96666 14.1667H1.33333C1.05999 14.1667 0.833328 14.3934 0.833328 14.6667C0.833328 14.94 1.05999 15.1667 1.33333 15.1667H14.6667C14.94 15.1667 15.1667 14.94 15.1667 14.6667C15.1667 14.3934 14.94 14.1667 14.6667 14.1667ZM8 6Q8 9.5 11.5 9.5Q8 9.5 8 13Q8 9.5 4.5 9.5Q8 9.5 8 6Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }